import React, { useState } from 'react';
import axios from 'axios';
import { toast } from 'sonner';
import { Handshake } from 'lucide-react';
import { API } from '../../constants';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '@/components/ui/dialog';

export const TalkToSalesButton = ({ label = 'Talk to sales — 50+ NOCs' }) => {
  const [open, setOpen] = useState(false);
  const EMPTY_LEAD = { name: '', company: '', email: '', phone: '', monthly_volume: '', message: '' };
  const [f, setF] = useState(EMPTY_LEAD);
  const send = async () => {
    try { await axios.post(`${API}/sales/leads`, f); toast.success("Thanks — our sales team will reach out shortly."); setF(EMPTY_LEAD); setOpen(false); }
    catch (e) { toast.error(e.response?.data?.detail || 'Could not send'); }
  };
  return (
    <>
      <Button variant="outline" onClick={() => setOpen(true)} data-testid="talk-to-sales-btn"><Handshake className="h-4 w-4 mr-1" /> {label}</Button>
      <Dialog open={open} onOpenChange={setOpen}>
        <DialogContent data-testid="talk-to-sales-dialog">
          <DialogHeader><DialogTitle>Talk to sales</DialogTitle></DialogHeader>
          {[['name', 'Your name *'], ['company', 'Company'], ['email', 'Email *'], ['phone', 'Phone'], ['monthly_volume', 'About how many NOCs a month?'], ['message', 'Anything else']].map(([k, l]) => (
            <Input key={k} placeholder={l} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`sales-lead-${k}`} />
          ))}
          <Button onClick={send} className="bg-[#F97316] hover:bg-[#F97316]/90" data-testid="sales-lead-submit">Send</Button>
        </DialogContent>
      </Dialog>
    </>
  );
};
